import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { EmployeeAddress } from '@qaroni-app/employee/types/employee-address';
import { qaroniAnimations } from '@qaroni-shared/animations/qaroni-animations';

@Component({
  selector: 'qaroni-employee-profile-address-preview',
  templateUrl: './employee-profile-address-preview.component.html',
  styleUrls: ['./employee-profile-address-preview.component.scss'],
  animations: [qaroniAnimations.enterFadeIn()],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EmployeeProfileAddressPreviewComponent {
  readonly employeeAddress = input<EmployeeAddress | null>(null);
}
